import script from "./GlobusMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusMessage.vue?vue&type=script&setup=true&lang=js"

import "./GlobusMessage.vue?vue&type=style&index=0&id=a56fb264&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a56fb264"]])

export default __exports__